import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MessageService } from '@philips-emr/tws-core/lib/services';

@Controller({ fragment: 'root' })
class MainController {

  @OnMount({ target: 'layout-root' })
  onRootLayoutMount(): void {
    document.title = MessageService.translate('provider.application-name');
  }

}

export default MainController;
